<app-dashboard-layout [loading]="loading" [downloader]="downloader" [dialog]="dialog">
  <section class="bg-white border rounded-md p-4">
    <header class="border-b flex text-lg w-full pb-4 gap-8 md:text-xl grid gap-4 grid-cols-2">
      <div class="">
        {{isCart ? 'Cart' : 'Order Details'}}
      </div>
      <div class="text-right">
        <app-button-primary *ngIf="isCart && cart.ItemCount! > 0" type="button" [disabled]="loading" (click)="checkoutClicked()">  
          <div class="material-icons">credit_score</div>
          <div>
            Buy Items 
          </div>
        </app-button-primary>
      </div>
    </header>

    <app-notification-alert [data]="apiService.notification"></app-notification-alert>
    <div *ngIf="skeletonLoader" class="grid pb-4 gap-4 gap-8 grid-cols-1 md:grid-cols-4">
      <div *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]" class="border rounded-md bg-gray-300 h-20 animate-pulse"></div>
    </div>
    <table *ngIf="!skeletonLoader && cart.ItemCount! > 0" class="w-full text-sm text-left text-gray-600">
      <thead class="text-xs text-gray-700 bg-primary/5">
        <tr>
          <th scope="col" class="w-1/2 py-3 px-6 text-left">
            Item
          </th>                                
          <th scope="col" class="w-1/6 py-3 px-6 text-center">        
            Quantity
          </th>
          <th scope="col" class="w-1/6 py-3 px-6 text-right">
            Unit Price
          </th>
          <th scope="col" class="w-1/6 py-3 px-6 text-right">
            Amount
          </th>
          <th scope="col" class="w-1/6 py-3 px-6 text-center">
            {{isCart ? "" : 'Status'}}
          </th>
          <th *ngIf="!isCart" scope="col" class="w-1/6 py-3 px-6 text-center">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of cart.OrderItems; let i = index" class="bg-white border-b">
          <td class="py-4 px-6 text-left">
            {{item.ShopItemName}}
          </td>
          <td class="py-4 px-6 text-center">
            {{item.Quantity}}
          </td>
          <td class="py-4 px-6 text-right">
            ₦ {{item.PricePerQuantity.toLocaleString()}}
          </td>
          <td class="py-4 px-6 text-right">
            ₦ {{item.Amount.toLocaleString()}}
          </td>
          <td *ngIf="!isCart" class="py-4 text-center">
            {{item.Status}}
          </td>
          <td *ngIf="isCart" (click)="toggleDeleteDialog(item.ShopItemFeeID)" class="py-4 px-6 text-center text-error cursor-pointer">
            <div class="material-icons">delete</div>
          </td>
          <td *ngIf="!isCart" class="py-4 text-center">
            <div *ngIf="item.Status == 'Open'" (click)="toggleDeleteDialog(item.ShopItemFeeID)" class="material-icons text-error cursor-pointer">cancel</div>
          </td>
        </tr>
      </tbody>
      <tfoot class="text-xs text-gray-700 bg-primary/5">
        <tr>
          <th scope="col" class="py-3 px-6 text-left">
            Total Amount
          </th>                                
          <th scope="col" class="py-3 px-6"></th>
          <th scope="col" class="py-3 px-6"></th>
          <th scope="col" class="py-3 px-6 text-right">
            ₦ {{cart.TotalAmount?.toLocaleString()}}
          </th>
          <th scope="col" class="py-3 px-6"></th>
          <th *ngIf="!isCart" scope="col" class="py-3 px-6"></th>
        </tr>
      </tfoot>
    </table>
    <app-no-content *ngIf="!skeletonLoader && cart.ItemCount! == 0"></app-no-content>
    
  </section>



  <app-confirmation-dialog [confirmationText]="confirmationText" [confirmDialog]="showConfirmDialog" (shouldConfirm)="checkoutCart($event)"></app-confirmation-dialog>
  <app-delete-dialog [confirmationText]="confirmationText" [deleteDialog]="showDeleteDialog" (shouldDelete)="deleteFromCart($event)"></app-delete-dialog>
  
</app-dashboard-layout>
